import { h } from "@stencil/core";
const state = {};
const render = () => (h("ch-textblock", { accessibleRole: state.accessibleRole, autoGrow: state.autoGrow, caption: state.caption, format: state.format, showTooltipOnOverflow: state.showTooltipOnOverflow }, h("ul", null, h("li", null, "Item 1"), h("li", null, "Item 2"), h("li", null, "Item 3")), h("p", null, "Some ", h("i", null, "custom"), " ", h("b", null, "HTML")), h("h2", null, "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis."), h("b", null, "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis."), h("i", null, "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis."), h("b", null, "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis."), h("i", null, "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis."), h("b", null, "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.")));
const showcaseRenderProperties = [
    {
        caption: "Properties",
        properties: [
            {
                id: "caption",
                caption: "Caption",
                value: `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.

  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.
  
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.
  
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.

  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.
  
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.
  
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.
  
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.
  
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.
  
  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt hic quos quia provident odit ad praesentium voluptas! Id aspernatur eum veniam odio consequuntur ea culpa aut unde, reprehenderit fugit perspiciatis.`,
                render: "textarea",
                type: "string"
            },
            {
                id: "accessibleRole",
                caption: "Accessible Role",
                value: "p",
                values: [
                    { caption: "Heading 1", value: "h1" },
                    { caption: "Heading 2", value: "h2" },
                    { caption: "Heading 3", value: "h3" },
                    { caption: "Heading 4", value: "h4" },
                    { caption: "Heading 5", value: "h5" },
                    { caption: "Heading 6", value: "h6" },
                    { caption: "Paragraph", value: "p" }
                ],
                type: "enum"
            },
            {
                id: "format",
                caption: "Format",
                value: "text",
                type: "enum",
                render: "radio-group",
                values: [
                    { value: "HTML", caption: "HTML" },
                    { value: "text", caption: "Text" }
                ]
            },
            {
                id: "autoGrow",
                caption: "Auto Grow",
                value: false,
                type: "boolean"
            },
            {
                id: "showTooltipOnOverflow",
                caption: "Show Tooltip On Overflow",
                value: false,
                type: "boolean"
            }
        ]
    }
];
export const textBlockShowcaseStory = {
    properties: showcaseRenderProperties,
    render: render,
    state: state
};
